<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button
      fill="clear"
      slot="start"
      (click)="close()"
      *ngIf="!closeButton">
      Back
    </ion-button>
    <ion-title>Qr Settings</ion-title>
    <ion-button fill="clear" slot="end" (click)="close()" *ngIf="closeButton">
      <ion-icon
        name="close-outline"
        sxCursor="pointer"
        sxTextSize="30px"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>

  <div *ngIf="scanner && scanner.scannerTemplateOptions" sxHeight="full">
    <div
      #qrwrapper
      class="export-qr-view" sxCol sxAlign="center" sxPadding="15px 40px 0 40px"
      sxWidth="350px" sxRadius="30px" sxMargin="0 auto">
      <p sxMargin="0" sxColor="#7e7e7e">Share IDs with</p>
      <img
        sxWidth="100px"
        sxMargin="10px 0 15px"
        alt="img"
        src="assets/imgs/qid-text-white.png" />
      <div
        sxColor="black"
        sxBackground="white"
        sxRadius="20px 20px 0 0"
        sxCol
        sxAlign="center"
        sxPadding="medium">
        <qrcode [qrdata]="baseUrl + scanner.qr" [width]="200"></qrcode>

        <h1 sxMargin="5px 0" sxTextSize="medium" sxTextAlign="center">{{ scanner?.org?.name }}</h1>
        <p sxMargin="5px 0" sxTextSize="small">{{
          scanner?.scannerTemplateOptions?.length > 1 ? scanner?.commonTitle : scanner?.scannerTemplateOptions[0]?.template?.purpose
          }}</p>
        <img
          sxWidth="100px"
          sxMargin="10px 0 0 0"
          src="/assets/imgs/secure-icon.png"/>
      </div>
    </div>
    <div sxWidth="full" sxCol sxGap="10px" sxPadding="30px 15px 0 15px">
      <div sxRow sxWidth="full" sxGap="10px">
        <div
          sxCursor="pointer"
          sxWidth="fill"
          sxBackground="light"
          sxPadding="large"
          sxRadius="medium"
          sxRow
          sxAlign="center"
          sxDistribution="spaceBetween"
          sxGap="10px"
         (click)="copy()">
          <p sxMargin="0" sxFlexShrink="0">Copy link</p>
          <input sxWidth="fill" [value]="this.baseUrl + this.scanner.qr" [readonly]="true">
          <ion-icon sxWidth="22px" name="copy-outline"></ion-icon>
        </div>
      </div>
    </div>
    <div sxWidth="full" sxCol sxGap="10px" sxPadding="medium">
      <div sxRow sxWidth="full" sxGap="10px">
        <div
          sxCursor="pointer"
          sxWidth="fill"
          sxBackground="light"
          sxAlign="start"
          sxPadding="large"
          sxRadius="medium"
          sxRow
          sxDistribution="spaceBetween"
          (click)="shareToLocal()"
        >Download QR
          <ion-icon name="download-outline" style="font-size: 20px"></ion-icon>
        </div>
      </div>
    </div>

    <div sxPadding="medium" sxCol sxGap="10px" sxWidth="full">
      @if (scanner.scannerTemplateOptions?.length > 1) {
      <super-input
        sxWidth="full"
        [fieldCallback]="updateScannerField"
        [(value)]="scanner.commonTitle"
        label="Title"></super-input>
      }

      <h3 sxMargin="15px 15px 0">
        Connected Form{{scanner.scannerTemplateOptions.length > 1 ? 's' : ''}}
      </h3>

      @for (multipleOptions of scanner.scannerTemplateOptions; track $index; let index = $index) {
        @if (multipleOptions?.template) {
        <div
          sxBackground="light"
          sxRow
          sxAlign="center"
          sxDistribution="spaceBetween"
          sxPadding="medium"
          sxRadius="medium">
          <div sxCol sxGap="10px" sxWidth="fill">
            <p sxMargin="0" sxTextSize="medium">
              {{ multipleOptions.template.purpose }}
            </p>
          </div>
          <div sxRow sxAlign="center">
            @if (scanner?.scannerTemplateOptions.length > 1) {
              <super-button
                [action]="removeTemplateOption.bind(this, index)"
                padding="0"
                width="fit"
                height="fit"
                type="clear">
              <ion-icon
                name="close-outline"
                sxTextSize="30px"
                sxColor="dark"></ion-icon>
              </super-button>
            }
            @if ((orgId$ | async ) === multipleOptions.template?.org?._id) {
              <super-button
                (click)="viewTemplate(multipleOptions.template)"
                padding="0"
                width="fit"
                type="clear"
                height="fit">
              <ion-icon
                name="create-outline"
                sxTextSize="30px"
                sxColor="dark"></ion-icon>
              </super-button>
            }
          </div>
        </div>
        }
      }

      <super-button
        background="light"
        (click)="addTemplateOptions()">{{
        scanner?.scannerTemplateOptions.length > 1
          ? 'Add More Options'
          : 'Connect Multiple Forms'
        }}</super-button
      >
      <p sxNote sxPadding="0 2px">
        You can link multiple forms with one QR code. Upon Scanning this QR
        user will be prompted with the options defined by you.
      </p>

      <super-button
        confirmationTitle="Delete?"
        background="light"
        color="danger"
        [action]="delete"
        sxMargin="0 0 70px 0"
      >Delete
      </super-button>
    </div>
  </div>


</ion-content>
